<template>

    <CDropdown variant="nav-item" style="margin-top: 10px;">
      <CDropdownToggle placement="bottom-end" class="py-0" :caret="true">
         <CIcon  icon="cil-bell"  size="lg"  class="position-relative text-white"/>
         <CBadge color="danger" position="top-end" shape="rounded-pill" class="ml-auto">{{ notifications.length }}</CBadge>
      </CDropdownToggle>
      <CDropdownMenu class=" pt-0" style="max-height: 300px; overflow-y: auto;">
        <CDropdownItem v-if="notifications.length" class="cursor-pointer py-3" @click="readNotificationAll"> 
          <CIcon icon="cil-check-circle" />
          Marcar todos como leidos
        </CDropdownItem>
        <CDropdownItem v-else class="cursor-pointer py-3"> 
          Estas al día con todos los mensajes
        </CDropdownItem>
        <CDropdownItem v-for="(notification,key) in notifications" :key="key" class="cursor-pointer py-3"> 
          <CIcon icon="cil-task" /> 
          <a @click.prevent="toPage('/'+notification.link, notification.id)" class="a_href">
            {{notification.data}}
          </a>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>

    <CDropdown variant="nav-item">
      <CDropdownToggle  placement="bottom-end" class="mx-2 px-2 d-flex align-items-center gap-2" :caret="false">
        <CAvatar :src="avatarSrc" size="md" />
        <span class="points-pill" :class="{ 'pill-blink': blink }" title="Ver tus fichas completadas" @click.stop.prevent="openMyClients">★ {{ points }}</span>
      </CDropdownToggle>
      <CDropdownMenu class="pt-0">
        <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
          {{user?.firstname+' '+user?.lastname }}
        </CDropdownHeader>
        <CDropdownDivider/>
        <CDropdownItem @click="$router.push('/tasks')">
          <CIcon name="cil-task" /> Tareas
          <CBadge color="danger" class="ml-auto">{{ task_items }}</CBadge>
        </CDropdownItem>
        <CDropdownDivider/>
        <CDropdownItem 
          v-if="user_prev != null" 
          @click="restore"
        >
          <CIcon name="cil-user" /> 
            Restaurar Sesión Anterior
        </CDropdownItem>
        <CDropdownDivider/>
        <CDropdownItem @click="logout"> 
          <CIcon icon="cil-lock-locked" /> 
          Cerrar Sesión 
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>

   <CToaster placement="top-end" visible>
    <CToast
       v-for="not in notification"
      :key="'toast' + not.id"
      :show="true"
      header="Nueva notificación"
      
    >
      <CToastHeader closeButton></CToastHeader>
      <CToastBody>
        {{not.data}}
      </CToastBody>
    </CToast>
</CToaster>

<Teleport to="body">
  <div v-if="myOpen" class="mp-backdrop" @click.self="closeMy">
    <div class="mp-modal">
      <div class="mp-head">
        <span class="mp-star">★</span>
        <div class="mp-titles">
          <div class="mp-title">Tus {{ points }} punto{{ points === 1 ? '' : 's' }}</div>
          <div class="mp-sub">Fichas que has completado</div>
        </div>
        <button class="mp-close" @click="closeMy" aria-label="Cerrar">×</button>
      </div>
      <div class="mp-body">
        <div v-if="myLoading" class="mp-empty">Cargando…</div>
        <div v-else-if="!myClients.length" class="mp-empty">Aún no has completado ninguna ficha. ¡A por la primera! ⭐</div>
        <a v-else v-for="c in myClients" :key="c.id" class="mp-cli" :href="'#/customers/' + c.id + '/edit'" @click="closeMy">
          <span class="mp-cli-name">{{ titleCase(c.firstname + ' ' + c.lastname) }}</span>
          <span class="mp-cli-date">{{ fecha(c.profile_completed_at) }}</span>
        </a>
      </div>
    </div>
  </div>
</Teleport>

</template>

<script>
import avatar from '@/assets/images/avatars/8.jpg'
import jwtToken from '../plugins/jwt/jwt-token';
import user from '../plugins/jwt/user' ; 
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { useUserStore } from '@/plugins/store';
import { loadIntranetPhotos, intranetPhoto } from '@/plugins/intranetPhotos';
import PushJs from 'push.js'
import Pusher from 'pusher-js'
import $ from 'jquery'

var TheHeader;

function getNotification(data) {
  TheHeader.addNotification(data);
  TheHeader.getNotifications();
}

const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
});

export default {
  name: 'AppHeaderDropdownAccnt',
  data () {
    return { 
      avatar: avatar,
      itemsCount: 42,
      baseURL : null,
      task_items : 0,
      points : 0,
      blink : false,
      myOpen : false,
      myClients : [],
      myLoading : false,
      notifications:[],
      user : null,
      user_prev : JSON.parse(user.getUserPrev())
    }
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  computed: {
    // Foto del usuario: la de la intranet (red.jurisleg) por email; si no, la local.
    avatarSrc() {
      return intranetPhoto(this.user?.email) || (this.baseURL + 'img/profiles/' + (this.user?.image || 'default.png'));
    },
  },
  created() {

    //Pusher.logToConsole = true;
    TheHeader = this
    this.user = this.userStore.getUser
    
    if (process.env.NODE_ENV === 'production') {
      const pusherKey = process.env.VUE_APP_PUSHER_KEY || '91ab7afa0f283ea405d5';
      const pusherCluster = process.env.VUE_APP_PUSHER_CLUSTER || 'eu';

      var pusher = new Pusher(pusherKey, {
        cluster: pusherCluster
      });

      var channel = pusher.subscribe('my-notification-'+this.user?.id);

      channel.bind(`my-notification-event`, function(data) {
        getNotification(data);

        PushJs.create("Hexcrm: Nueva Notificación",{
          body: data.data,
          icon: '/public/apple-icon-152x152.png',
          onClick: function () {
            window.focus();
            TheHeader.$router.push({ path : data.link})
          }
        });
      });
    }

    this.baseURL = axios.defaults.baseURL;
    loadIntranetPhotos();   // fotos de usuarios desde la intranet (cacheado)
    this.getTaskPending();
    this.getMyPoints();
    this.getNotifications()
    //this.readNotification()

    // Cuando se premia un punto (al completar una ficha), refresca el contador
    // en vivo y hace parpadear la píldora — sin necesidad de recargar la página.
    this._onPointsAwarded = () => { this.getMyPoints(); this.pulse(); };
    window.addEventListener('points-awarded', this._onPointsAwarded);
  },
  mounted(){
    $('[placement="bottom-end"]').removeAttr('href')
  },
  beforeUnmount(){
    if (this._onPointsAwarded) window.removeEventListener('points-awarded', this._onPointsAwarded);
  },
  methods: {
    addNotification(data){
      this.notification = [];
      this.notification.push(data);
    },
    toPage(to, id){
      this.readNotification(id)
      console.log(to)
      this.$router.push(to)
    },
    getMyPoints(){
      axios.get('v1/users/me')
        .then(resp => { this.points = resp.data.points || 0 })
        .catch(() => {});
    },
    pulse(){
      this.blink = false;
      this.$nextTick(() => {
        this.blink = true;
        setTimeout(() => { this.blink = false; }, 2600);
      });
    },
    openMyClients(){
      this.myOpen = true;
      this.myClients = [];
      this.myLoading = true;
      // Refresca el contador de la cabecera a la vez que la lista: si por lo
      // que sea se perdió el evento 'points-awarded' (pestaña abierta mucho
      // rato, varias fichas completadas seguidas...), el número se quedaba
      // desincronizado de la lista real aunque el punto SÍ estuviera guardado
      // en el servidor — la lista siempre viene fresca, el contador no.
      this.getMyPoints();
      const id = this.user?.id;
      axios.get('v1/users/' + id + '/completed-profiles')
        .then(r => { this.myClients = r.data || []; })
        .catch(err => console.log(err))
        .finally(() => { this.myLoading = false; });
    },
    closeMy(){ this.myOpen = false; },
    titleCase(s){ return String(s || '').toLowerCase().replace(/\b\p{L}/gu, c => c.toUpperCase()); },
    fecha(v){
      if (!v) return '';
      const d = new Date(String(v).replace(' ', 'T'));
      return isNaN(d) ? '' : d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    getTaskPending(){
      axios
      .get('v1/tasks/Pendiente/status')
      .then(resp => {
        this.task_items = resp.data.filter((thing, index) => {
          const _thing = JSON.stringify(thing);
          return index ===  resp.data.findIndex(obj => {
            return JSON.stringify(obj) === _thing;
          });
        }).length;
       })
      .catch(err => console.log(err));
    },
    getNotifications(){
      axios
      .get('v1/users/notifications')
      .then(resp => {
        this.notifications = resp.data.data
       })
      .catch(err => console.log(err));
    },
    readNotification(id){
      axios
      .post('v1/users/read_at',{
        id: id
      })
      .then(resp => {
        console.log(resp)
        this.getNotifications()
       })
      .catch(err => console.log(err));
    },
    readNotificationAll(){
      axios
      .get('v1/users/read_at_all')
      .then(resp => {
        console.log(resp)
        this.getNotifications()
        Toast.fire({
          icon: 'success',
          title: 'NOTIFICACIONES MARCAS COMO LEÍDO CON ÉXITO',
        })
       })
      .catch(err => console.log(err));
    },
    logout(){
      this.userStore.logout()
      .finally(() => {
        window.location.href = window.location.pathname;
        //location.href= '#/pages/login'
      })
    },
    restore(){
      let user_ = JSON.parse(user.getUserPrev())
      
      this.userStore.restore(user_.id)
      .then(response => {
        user.setUser(response.data.user)
        user.removeUserPrev()
        jwtToken.setToken(response.data.access_token);
        this.getOrganization()
      })
      .catch(err => {
        console.log(err);
        Toast.fire({
          icon: 'error',
          title: 'ACCESO DENEGADO',
        })
        localStorage.removeItem('token')
      });
    },
    getOrganization(){
      this.userStore.getOrganization()
      .then(res => {
        console.log(res)
        this.getParents()
      })
      .catch(err => {
        console.log(err)
        localStorage.removeItem('token')
      });
    },
    getParents(){
      this.userStore.getParents()
      .then(res => {
        console.log(res)
        this.$router.go(0)
      })
      .catch(err => {
        console.log(err)
      });
    },
  } 
}
</script>
<style scoped>
  .cursor-pointer{
    cursor: pointer;
  }
  .points-pill {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: rgba(255, 255, 255, 0.15);
    color: #ffd76a;
    font-size: 12px;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 20px;
    white-space: nowrap;
    line-height: 1.3;
    transition: transform .2s ease;
    cursor: pointer;
  }
  .points-pill:hover { background: rgba(255, 255, 255, 0.28); }
  .points-pill.pill-blink {
    animation: pill-blink 0.5s ease-in-out 4;
  }
  @keyframes pill-blink {
    0%, 100% { transform: scale(1); background: rgba(255, 255, 255, 0.15); color: #ffd76a; box-shadow: 0 0 0 rgba(255, 215, 106, 0); }
    50% { transform: scale(1.45); background: rgba(255, 224, 130, 0.95); color: #7a5200; box-shadow: 0 0 18px rgba(255, 215, 106, 0.95); }
  }

  /* Modal "tus fichas completadas" */
  .mp-backdrop {
    position: fixed; inset: 0; background: rgba(20, 30, 40, .45);
    display: flex; align-items: center; justify-content: center;
    z-index: 20050; padding: 16px;
  }
  .mp-modal {
    background: #fff; border-radius: 16px; width: 100%; max-width: 440px;
    max-height: 80vh; display: flex; flex-direction: column;
    box-shadow: 0 18px 50px rgba(0, 0, 0, .25); overflow: hidden;
  }
  .mp-head {
    display: flex; align-items: center; gap: 12px; padding: 16px 18px;
    background: linear-gradient(135deg, #f5a623, #f7b733); color: #fff;
  }
  .mp-star { font-size: 30px; line-height: 1; text-shadow: 0 0 10px rgba(255,255,255,.6); }
  .mp-titles { flex: 1 1 auto; min-width: 0; }
  .mp-title { font-size: 17px; font-weight: 800; }
  .mp-sub { font-size: 12.5px; opacity: .95; margin-top: 1px; }
  .mp-close {
    background: rgba(255,255,255,.25); border: 0; color: #fff; cursor: pointer;
    width: 30px; height: 30px; border-radius: 50%; font-size: 20px; line-height: 1; flex: 0 0 auto;
    transition: background .15s;
  }
  .mp-close:hover { background: rgba(255,255,255,.4); }
  .mp-body { padding: 8px 10px; overflow-y: auto; }
  .mp-empty { text-align: center; color: #9aa2b1; font-size: 13.5px; padding: 26px 14px; }
  .mp-cli {
    display: flex; align-items: center; justify-content: space-between; gap: 10px;
    padding: 11px 12px; border-radius: 10px; text-decoration: none;
    color: #2c3038; border-bottom: 1px solid #f2f3f6; transition: background .12s;
  }
  .mp-cli:last-child { border-bottom: 0; }
  .mp-cli:hover { background: #fff9ee; }
  .mp-cli-name { font-size: 13.5px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .mp-cli-date { font-size: 12px; color: #9aa2b1; flex: 0 0 auto; }
</style>